import produce from 'immer';
import { AppActionType, } from './actions';
const appSettingsReducer = (currentState, action) => {
    const { type } = action;
    switch (type) {
        case AppActionType.SET_APP_SETTINGS:
            const actualAction = action;
            return actualAction.appSettings;
        default:
            return currentState;
    }
};
export const appStateReducer = (currentState, action) => {
    return produce(currentState, (draft) => {
        draft.appSettings = appSettingsReducer(currentState.appSettings, action);
    });
};
